const validate = (value, args) => {
  let result = false
  if (typeof value === 'number') {
    value = value.toString()
  } else if (typeof value !== 'string') {
    value = ''
  }
  if (!!value.length && /[0-9]/.test(value) && value.length === 13) {
    const n13 = parseInt((parseInt(value.slice(0, -1)) % 11).toString().slice(-1))
    if (n13 === parseInt(value[12])) {
      result = true
    }
  }
  return result
}

export default {
  validate
}
